import { render, staticRenderFns } from "./ListPatroliJalanRayaPage.vue?vue&type=template&id=70d3bb30&scoped=true"
import script from "./ListPatroliJalanRayaPage.vue?vue&type=script&lang=js"
export * from "./ListPatroliJalanRayaPage.vue?vue&type=script&lang=js"
import style0 from "./ListPatroliJalanRayaPage.vue?vue&type=style&index=0&id=70d3bb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3bb30",
  null
  
)

export default component.exports